@if (isLoading || recipeCards?.length > 0) {
  <sd-recipe-list
    [recipes]="recipeCards"
    [totalCount]="totalCount"
    [showSize]="isMobile$ ? 3 : 1"
    [showedRow]="isMobile$ ? 3 : 1"
    [twicPicsAutoSize]="!isFirst"
    [isLoading]="isLoading"
    (recipeClicked)="recipeClicked($event)"
    [brand]="brandCorner"
  />
}
